import DetailTitle from "@/components/DetailTitle";
import TxtEditor from "@/components/TxtEditor";
import MdEditor from "@/components/MdEditor";
import { Tooltip, Table, Tag, Modal } from "antd";
import styles from "./index.module.scss";
import downImg from "@/assets/images/discover/down.png";
import viewImg from "@/assets/images/discover/view.png";
import { dealFileSize } from "@/utils/dealFileSize";
import intl from "react-intl-universal";
import { downloadFile, getResourceFileDownloadUrl } from "@/apis/discover";
import { useState,useRef } from "react";
import './index.scss';
const HowToUse = ({ resourceUuid, files }) => {
  const downLoadFileById = async (id) => {
    try {
      const url = await getResourceFileDownloadUrl(resourceUuid, id);
      window.location.assign(url);
    } catch (error) {
      // The shared request handler displays errors and opens the login dialog when required.
    }
  };
  const [textContent, setContent] = useState("");
  const fetchTxt = async (fileUuid) => {
    try {
      const res = await downloadFile({ resourceUuid, fileUuid });
      setContent(res.data);
    } catch (error) {
      console.log(error);
    }
  };
  const mdRef = useRef(null);
  const txtRef = useRef(null);

  const [open, setOpen] = useState(false);
  const [fileUuid, setFileUuid] = useState("");
  const [fileName, setFileName] = useState("");
  const [fileFormat, setFileFormat] = useState("");
  const loading = false;
  const editFile = (e) => {
    setFileUuid(e.fileUuid);
    setFileName(e.fileName);
    setFileFormat(e.fileFormat);
    fetchTxt(e.fileUuid);
    setOpen(true);
  };
  const columns = [
    {
      title: intl.get("Share.File Name"),
      key: "fileName",
      dataIndex: "fileName",
      width: 500,
    },
    {
      title: intl.get("Share.File Type"),
      key: "fileType",
      dataIndex: "fileFormat",
      width: 90,
      render: (text, record, index) => <Tag color="gold">{text}</Tag>,
    },
    {
      title: intl.get("Share.File Size"),
      key: "fileSize",
      dataIndex: "fileSize",
      width: 90,
      render: (text, record, index) => <span>{dealFileSize(text)}</span>,
    },
    {
      title: intl.get("Operation"),
      key: "operate",
      width: 90,
      render: (text, record) => (
        <div className={styles.downBox}>
          <Tooltip title={intl.get("Share.Download the file")}>
            <img
              src={downImg}
              onClick={() => downLoadFileById(record.fileUuid)}
            />
          </Tooltip>
          <Tooltip title={intl.get("Discover.View")}>
          <img
              src={viewImg}
              onClick={() => editFile(record)}
            />
          </Tooltip>
        </div>
      ),
    },
  ];
  return (
    <div>
      <DetailTitle title="How To Use" />
      <Table
        rowKey={(record) => record.fileUuid}
        size="small"
        scroll={{ y: "350px" }}
        pagination={false}
        dataSource={files}
        columns={columns}
      />
      <Modal
        title={fileName}
        loading={loading}
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        width={1200}
      >
        <MdEditor ref={mdRef} fileUuid={fileUuid} textContent={textContent} />
      </Modal>
    </div>
  );
};
export default HowToUse;
